(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  const HeaderAppZone = {
    init: function() {
      this.setupCategories();
      this.setupAppZones();
      this.preventZIndexConflicts();
    },

    setupCategories: function() {
      const openButton = document.getElementById("nostri-libri-btn");
      const modal = document.getElementById("MenuModal-categories");
      const closeButton = document.getElementById("ModalClose-categories");

      if (!openButton) return;

      openButton.addEventListener("click", function(e) {
        e.preventDefault();
        modal.style.display = "flex";
      });

      if (closeButton) {
        closeButton.addEventListener("click", function() {
          modal.style.display = "none";
        });
      }

      window.addEventListener("click", function(event) {
        if (event.target === modal) {
          modal.style.display = "none";
        }
      });
    },

    setupAppZones: function() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            this.isolateAppStyles();
          }
        });
      });

      const appZones = document.querySelectorAll('.header__app-zone');
      appZones.forEach(zone => {
        observer.observe(zone, {
          childList: true,
          subtree: true,
          attributes: false
        });
      });

      this.isolateAppStyles();
    },

    isolateAppStyles: function() {
      document.querySelectorAll('.header__app-block').forEach(block => {
        if (block.shadowRoot) {
          block.shadowRoot.querySelectorAll('style').forEach(style => {
            style.textContent = this.namespaceCSS(style.textContent);
          });
        }
      });
    },

    namespaceCSS: function(css) {
      return css.replace(/^(\s*[^{]+)\{/gm, '.header__app-block $1 {');
    },

    preventZIndexConflicts: function() {
      document.querySelectorAll('.header__app-block').forEach(block => {
        const elements = block.querySelectorAll('[style*="z-index"]');
        elements.forEach(el => {
          const zIndex = parseInt(window.getComputedStyle(el).zIndex) || 0;
          if (zIndex > 9998) {
            el.style.zIndex = '9998';
          }
        });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => HeaderAppZone.init());
  } else {
    HeaderAppZone.init();
  }

  window.addEventListener('beforeunload', () => {
    HeaderAppZone = null;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
